import { ActionLink } from "@/components/action-link";
import { CheckoutShell } from "@/components/checkout-shell";
import { StatusBlock } from "@/components/status-block";
import { CircleSlash } from "lucide-react";

/**
 * Reachable only by typing a path: `not_found_handling` is
 * "single-page-application" (see src/app-type.ts), so every unmatched deep
 * link falls through to index.html and lands here rather than on a 404.
 *
 * Kept in the same frame as the rest, and kept vague on purpose — this app
 * has no map to offer a lost visitor beyond the front door, and a shopper who
 * mistypes their way here mid-transaction is best served by the one link
 * that definitely works.
 */
export function NotFoundPage() {
  return (
    <CheckoutShell title="Page not found · Sara's Books">
      <StatusBlock
        tone="held"
        icon={<CircleSlash className="size-4.5" aria-hidden />}
        title="Page not found"
        body="There is nothing at this address. If you were part-way through a purchase, return to the store you started in and try again — nothing has been charged."
      >
        <ActionLink href="https://sara.ai" variant="outline">
          Return to sara.ai
        </ActionLink>
      </StatusBlock>
    </CheckoutShell>
  );
}
